<template>
  <cx-showcase-section :name="name" :link="link" class="cx-checkbox-showcase">
    <cx-checkbox v-model:checked="isChecked" label="label1" tooltip="label1"/>
    <cx-checkbox v-model:checked="isChecked2" @click="onClick" tooltip="CxCheckbox without label"/>
    <cx-checkbox v-model:checked="isChecked3" :disabled="true" @click="onClick" tooltip="disabeld CxCheckbox"/>
    <cx-checkbox class="cx-checkbox__4" v-model:checked="isChecked4" tooltip="suuper long CxCheckbox" label="Suuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuper loooooooooooooong conteeeent"/>
    <cx-multiselect-bar :value="multibarData" @onSelectedChange="onSelectedChangeHandler"/>
  </cx-showcase-section>
</template>

<script>
import CxShowcaseSection from '../CxShowcaseSection';
import CxCheckbox from '@/components/CxCheckbox';
import CxMultiselectBar from '@/components/CxMultiselectBar';

export default {
  name: 'CxToggleShowcase',
  components: {
    CxShowcaseSection,
    CxCheckbox,
    CxMultiselectBar
  },
  data() {
    return {
      name: 'CxCheckbox',
      link: '',
      isChecked: false,
      isChecked2: false,
      isChecked3: false,
      isChecked4: false,
      multibarData: [{ label: 'label1', isSelected: false }, { label: 'label2', isSelected: true }]
    };
  },
  methods: {
    onClick() {
      // eslint-disable-next-line no-console
      console.log('checkbox clicked');
    },
    onSelectedChangeHandler({ index, value }) {
      this.multibarData[index].isSelected = value;
    }
  },
};

</script>

<style lang="less">
@import '../../../common';

.cx-checkbox__4 {
  max-width: 100px;
}

</style>